import Svg from '@app/components/svg';

const Files = Svg(
  <>
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 7h-3a2 2 0 0 1-2-2V2"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"
    />
  </>,
  {
    viewBox: '0 0 24 24',
    fill: 'none',
  },
);

Files.displayName = 'Files';

export default Files;
